import { combineReducers } from 'redux'
import flash from './flash'
import progress from './progress'
import channels from './channels'
import createMetaReducer from './meta'
import resources from './resources'
import errors from './errors'
import searchResults from './search_results'
import uiReducer from './ui'
import settingsReducer from './settings'
import { persistReducer } from 'redux-persist'
import localStorage from 'redux-persist/lib/storage'
import sessionStorage from 'redux-persist/lib/storage/session'
import { connectRouter } from 'connected-react-router'
import orm from 'models'
import { createReducer } from 'redux-orm'

import modelReducer from './form/model-reducer'


export const createRootReducer = (history) => { return (state, action) => {
  if (action.type === 'CLEAR_STORE') {
    state = undefined
  } // Move this to logic for clearing

  return combineReducers({
    router: connectRouter(history),
    flash: flash,
    admin: () => { return false },
    errors: errors,
    entities: (state, action) => {
      const intermediateState = createReducer(orm) (state, action)
      const finalState = modelReducer(`entities`, {})(intermediateState, action)
      return finalState;
    },
    meta: createMetaReducer(orm),
    resources: resources, // TODO: make as entity
    searchResults: searchResults,
    channels: channels,
    progress: progress,
    settings:  persistReducer({key: 'settings', storage: localStorage}, settingsReducer),
    // ui: persistReducer({ key: 'ui', storage: sessionStorage, blacklist: ['mainModal'] }, uiReducer),
    //
    ui: uiReducer // TODO Maybe persist with blacklist for DossierEditor
  })(state,action)
}}


